import React from 'react'

const HighrisesIcon = props => (
  <div {...props}>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>Highrises</title>
    <g id="Agent-Dashboard---Agent-Badges" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Badge/Small/Highrises">
            <g id="discount-badge-2" fill="#C4D2EB" fillRule="nonzero">
                <g id="discount-badge">
                    <circle id="Oval" cx="12" cy="12" r="12"></circle>
                </g>
            </g>
            <g id="Highrises-logo-Copy" transform="translate(6.000000, 4.500000)" fill="#0B4599">
                <polygon id="Rectangle" points="0 4.24684136 3 3 3 13.5 0 12.6574172"></polygon>
                <polygon id="Rectangle-Copy-5" points="9 0 12 0.714586072 12 14.5869362 9 15"></polygon>
                <polygon id="Rectangle-Copy-4" points="4.5 1.49248605 7.5 0 7.5 15 4.5 13.8234998"></polygon>
            </g>
        </g>
    </g>
    </svg>
  </div>
)

export default HighrisesIcon
